/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ budget: NonNullable<unknown> }} Sub_Quotas_Over_Budget_RaisedInputs */



/**
* | output |
* | --- |
* | "Total budget raised to {budget}." |
*
* @param {Sub_Quotas_Over_Budget_RaisedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_over_budget_raised = /** @type {((inputs: Sub_Quotas_Over_Budget_RaisedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Over_Budget_RaisedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Gesamtbudget auf ${i?.budget} erhöht.`)
	return /** @type {LocalizedString} */ (`Total budget raised to ${i?.budget}.`)
});